import script from "./CategorySelectCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySelectCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./CategorySelectCheckbox.vue?vue&type=style&index=0&id=157f0c7d&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-157f0c7d"]])

export default __exports__